// ═══════════════════════════════════════════════════════════════════════
// MANGALACHARAN — 20 Sacred Sanskrit Invocations
// A random shloka is spoken before every game as an auspicious opening.
// Sources: Bhagavad Gita, Upanishads, Yoga Sutras, Vedas, Subhashitas
// ═══════════════════════════════════════════════════════════════════════

export const MANGALACHARAN = [
  // ─── BHAGAVAD GITA ────────────────────────────────────────────────
  {
    id: 0,
    shloka: 'कर्मण्येवाधिकारस्ते मा फलेषु कदाचन ।\nमा कर्मफलहेतुर्भूर्मा ते सङ्गोऽस्त्वकर्मणि ॥',
    pronounce: 'Karmanye vadhikaraste, ma phaleshu kadachana\nMa karmaphala-hetur bhur, ma te sango\'stv akarmani',
    meaning_en: 'You have the right to perform your duty, but never to its fruits. Let not the fruits of action be your motive, nor let your attachment be to inaction.',
    meaning_hi: 'कर्म करने में ही तुम्हारा अधिकार है, फल में कभी नहीं। कर्मफल की इच्छा तुम्हारा प्रेरक न हो, और अकर्म में भी तुम्हारी आसक्ति न हो।',
    source: 'भगवद्गीता २.४७',
    source_en: 'Bhagavad Gita 2.47',
  },
  {
    id: 1,
    shloka: 'यदा यदा हि धर्मस्य ग्लानिर्भवति भारत ।\nअभ्युत्थानमधर्मस्य तदात्मानं सृजाम्यहम् ॥',
    pronounce: 'Yada yada hi dharmasya, glanir bhavati Bharata\nAbhyutthanam adharmasya, tadatmanam srijamy aham',
    meaning_en: 'Whenever there is a decline of righteousness and rise of unrighteousness, O Arjuna, then I manifest myself.',
    meaning_hi: 'जब-जब धर्म की हानि और अधर्म का उत्थान होता है, हे भारत, तब-तब मैं स्वयं को प्रकट करता हूँ।',
    source: 'भगवद्गीता ४.७',
    source_en: 'Bhagavad Gita 4.7',
  },
  {
    id: 2,
    shloka: 'नैनं छिन्दन्ति शस्त्राणि नैनं दहति पावकः ।\nन चैनं क्लेदयन्त्यापो न शोषयति मारुतः ॥',
    pronounce: 'Nainam chhindanti shastrani, nainam dahati pavakah\nNa chainam kledayanty apo, na shoshayati marutah',
    meaning_en: 'Weapons cannot cut the soul, fire cannot burn it, water cannot wet it, and wind cannot dry it. The soul is eternal, indestructible.',
    meaning_hi: 'इस आत्मा को शस्त्र नहीं काट सकते, अग्नि नहीं जला सकती, जल नहीं भिगो सकता, और वायु नहीं सुखा सकती। आत्मा शाश्वत और अविनाशी है।',
    source: 'भगवद्गीता २.२३',
    source_en: 'Bhagavad Gita 2.23',
  },
  {
    id: 3,
    shloka: 'सर्वधर्मान्परित्यज्य मामेकं शरणं व्रज ।\nअहं त्वां सर्वपापेभ्यो मोक्षयिष्यामि मा शुचः ॥',
    pronounce: 'Sarva-dharman parityajya, mam ekam sharanam vraja\nAham tvam sarva-papebhyo, mokshayishyami ma shuchah',
    meaning_en: 'Abandon all forms of dharma and surrender unto me alone. I shall deliver you from all sins. Do not grieve.',
    meaning_hi: 'सब धर्मों को त्यागकर केवल मेरी शरण में आओ। मैं तुम्हें सब पापों से मुक्त करूँगा। शोक मत करो।',
    source: 'भगवद्गीता १८.६६',
    source_en: 'Bhagavad Gita 18.66',
  },
  {
    id: 4,
    shloka: 'कालोऽस्मि लोकक्षयकृत्प्रवृद्धो\nलोकान्समाहर्तुमिह प्रवृत्तः ॥',
    pronounce: 'Kalo\'smi loka-kshaya-krit pravriddho\nLokan samahar-tum iha pravrittah',
    meaning_en: 'I am Time, the great destroyer of worlds, and I have come here to consume all beings.',
    meaning_hi: 'मैं काल हूँ, लोकों का विनाश करने वाला, प्रबल होकर यहाँ सब लोकों का संहार करने के लिए प्रवृत्त हुआ हूँ।',
    source: 'भगवद्गीता ११.३२',
    source_en: 'Bhagavad Gita 11.32',
  },
  {
    id: 5,
    shloka: 'बुद्धियुक्तो जहातीह उभे सुकृतदुष्कृते ।\nतस्माद्योगाय युज्यस्व योगः कर्मसु कौशलम् ॥',
    pronounce: 'Buddhi-yukto jahateeha, ubhe sukrita-dushkrite\nTasmad yogaya yujyasva, yogah karmasu kaushalam',
    meaning_en: 'The wise, united with pure intellect, cast off both good and evil deeds. Therefore strive for Yoga — Yoga is skill in action.',
    meaning_hi: 'बुद्धियुक्त मनुष्य यहीं पुण्य और पाप दोनों को त्याग देता है। इसलिए योग में लगो — योग ही कर्मों में कुशलता है।',
    source: 'भगवद्गीता २.५०',
    source_en: 'Bhagavad Gita 2.50',
  },
  {
    id: 6,
    shloka: 'उद्धरेदात्मनात्मानं नात्मानमवसादयेत् ।\nआत्मैव ह्यात्मनो बन्धुरात्मैव रिपुरात्मनः ॥',
    pronounce: 'Uddhared atmanatmanam, natmanam avasadayet\nAtmaiva hy atmano bandhur, atmaiva ripur atmanah',
    meaning_en: 'Elevate yourself by your own self. Do not degrade yourself. For the self alone is your friend, and the self alone is your enemy.',
    meaning_hi: 'अपने आप को स्वयं ऊपर उठाओ, अपने आप को गिराओ मत। क्योंकि आत्मा ही अपना मित्र है और आत्मा ही अपना शत्रु है।',
    source: 'भगवद्गीता ६.५',
    source_en: 'Bhagavad Gita 6.5',
  },

  // ─── UPANISHADS ───────────────────────────────────────────────────
  {
    id: 7,
    shloka: 'ईशावास्यमिदं सर्वं यत्किञ्च जगत्यां जगत् ।\nतेन त्यक्तेन भुञ्जीथा मा गृधः कस्यस्विद्धनम् ॥',
    pronounce: 'Ishavasyam idam sarvam, yat kincha jagatyam jagat\nTena tyaktena bhunjitha, ma gridhah kasya svid dhanam',
    meaning_en: 'All this — whatever exists in this moving world — is pervaded by the Divine. Enjoy through renunciation. Do not covet anyone\'s wealth.',
    meaning_hi: 'यह सब कुछ — जो भी इस गतिशील जगत में है — ईश्वर से व्याप्त है। त्याग के साथ भोग करो। किसी के धन का लोभ मत करो।',
    source: 'ईशोपनिषद् १',
    source_en: 'Isha Upanishad 1',
  },
  {
    id: 8,
    shloka: 'केनेषितं पतति प्रेषितं मनः\nकेन प्राणः प्रथमः प्रैति युक्तः ।\nकेनेषितां वाचमिमां वदन्ति\nचक्षुः श्रोत्रं क उ देवो युनक्ति ॥',
    pronounce: 'Keneshitam patati preshitam manah\nKena pranah prathamah praiti yuktah\nKeneshitam vacham imam vadanti\nChakshuh shrotram ka u devo yunakti',
    meaning_en: 'By whom directed does the mind fly to its object? By whom commanded does the first breath move? By whom is this speech uttered? What divine being directs the eyes and ears?',
    meaning_hi: 'किसकी प्रेरणा से मन अपने विषय की ओर जाता है? किसकी आज्ञा से प्राण चलता है? किसकी प्रेरणा से यह वाणी बोली जाती है? कौन देवता नेत्र और कान को प्रेरित करता है?',
    source: 'केनोपनिषद् १.१',
    source_en: 'Kena Upanishad 1.1',
  },
  {
    id: 9,
    shloka: 'नायमात्मा प्रवचनेन लभ्यो\nन मेधया न बहुना श्रुतेन ।\nयमेवैष वृणुते तेन लभ्यः\nतस्यैष आत्मा विवृणुते तनूं स्वाम् ॥',
    pronounce: 'Nayam atma pravachanena labhyo\nNa medhaya na bahuna shrutena\nYam evaisha vrinute tena labhyah\nTasyaisha atma vivrinute tanum svam',
    meaning_en: 'The Self cannot be attained by study, nor by intellect, nor by much learning. It is gained only by the one whom the Self chooses — to that one the Self reveals its own form.',
    meaning_hi: 'यह आत्मा न प्रवचन से, न बुद्धि से, न बहुत सुनने से प्राप्त होती है। जिसे यह स्वयं चुनती है, उसी को प्राप्त होती है — उसके सामने आत्मा अपना स्वरूप प्रकट करती है।',
    source: 'कठोपनिषद् १.२.२३',
    source_en: 'Katha Upanishad 1.2.23',
  },
  {
    id: 10,
    shloka: 'सत्यमेव जयते नानृतम्\nसत्येन पन्था विततो देवयानः ॥',
    pronounce: 'Satyameva jayate nanritam\nSatyena pantha vitato devayanah',
    meaning_en: 'Truth alone triumphs, not falsehood. Through truth is laid the path to the Divine.',
    meaning_hi: 'सत्य की ही विजय होती है, असत्य की नहीं। सत्य से ही देवयान मार्ग विस्तारित होता है।',
    source: 'मुण्डकोपनिषद् ३.१.६',
    source_en: 'Mundaka Upanishad 3.1.6',
  },
  {
    id: 11,
    shloka: 'असतो मा सद्गमय ।\nतमसो मा ज्योतिर्गमय ।\nमृत्योर्मा अमृतं गमय ॥',
    pronounce: 'Asato ma sad-gamaya\nTamaso ma jyotir-gamaya\nMrityor ma amritam gamaya',
    meaning_en: 'Lead me from the unreal to the real. Lead me from darkness to light. Lead me from death to immortality.',
    meaning_hi: 'मुझे असत्य से सत्य की ओर ले चलो। मुझे अंधकार से प्रकाश की ओर ले चलो। मुझे मृत्यु से अमृत की ओर ले चलो।',
    source: 'बृहदारण्यकोपनिषद् १.३.२८',
    source_en: 'Brihadaranyaka Upanishad 1.3.28',
  },
  {
    id: 12,
    shloka: 'तत् त्वम् असि ।',
    pronounce: 'Tat tvam asi',
    meaning_en: 'You are That. The individual self and the universal self are one and the same.',
    meaning_hi: 'तुम वही हो। व्यक्तिगत आत्मा और सार्वभौमिक आत्मा एक ही हैं।',
    source: 'छान्दोग्योपनिषद् ६.८.७',
    source_en: 'Chandogya Upanishad 6.8.7',
  },

  // ─── YOGA SUTRAS ──────────────────────────────────────────────────
  {
    id: 13,
    shloka: 'योगश्चित्तवृत्तिनिरोधः ॥',
    pronounce: 'Yogash chitta-vritti-nirodhah',
    meaning_en: 'Yoga is the cessation of the fluctuations of the mind.',
    meaning_hi: 'योग चित्त की वृत्तियों का निरोध है।',
    source: 'योगसूत्र १.२',
    source_en: 'Yoga Sutra 1.2 — Patanjali',
  },
  {
    id: 14,
    shloka: 'स्थिरसुखमासनम् ॥',
    pronounce: 'Sthira-sukham asanam',
    meaning_en: 'Posture should be steady and comfortable. Mastery comes from relaxation of effort and meditation on the infinite.',
    meaning_hi: 'आसन स्थिर और सुखद होना चाहिए। प्रयत्न के शिथिल होने और अनन्त पर ध्यान से इसकी सिद्धि होती है।',
    source: 'योगसूत्र २.४६',
    source_en: 'Yoga Sutra 2.46 — Patanjali',
  },

  // ─── SUBHASHITAS & WISDOM ─────────────────────────────────────────
  {
    id: 15,
    shloka: 'विद्या ददाति विनयं विनयाद्याति पात्रताम् ।\nपात्रत्वात् धनमाप्नोति धनात् धर्मं ततः सुखम् ॥',
    pronounce: 'Vidya dadati vinayam, vinayad yati patratam\nPatratvat dhanam apnoti, dhanat dharmam tatah sukham',
    meaning_en: 'Knowledge gives humility. From humility comes worthiness. From worthiness comes wealth. From wealth comes dharma. From dharma comes happiness.',
    meaning_hi: 'विद्या विनय देती है, विनय से पात्रता आती है, पात्रता से धन मिलता है, धन से धर्म होता है, और धर्म से सुख प्राप्त होता है।',
    source: 'सुभाषित',
    source_en: 'Subhashita — Hitopadesha',
  },
  {
    id: 16,
    shloka: 'उद्यमेन हि सिध्यन्ति कार्याणि न मनोरथैः ।\nन हि सुप्तस्य सिंहस्य प्रविशन्ति मुखे मृगाः ॥',
    pronounce: 'Udyamena hi sidhyanti, karyani na manorathaihi\nNa hi suptasya simhasya, pravishanti mukhe mrigah',
    meaning_en: 'Success comes through effort, not mere wishes. Prey does not walk into the mouth of a sleeping lion.',
    meaning_hi: 'कार्य उद्यम से सिद्ध होते हैं, मनोरथों से नहीं। सोते हुए सिंह के मुख में मृग स्वयं प्रवेश नहीं करते।',
    source: 'सुभाषित',
    source_en: 'Subhashita — Hitopadesha',
  },
  {
    id: 17,
    shloka: 'अयं निजः परो वेति गणना लघुचेतसाम् ।\nउदारचरितानां तु वसुधैव कुटुम्बकम् ॥',
    pronounce: 'Ayam nijah paro veti, ganana laghu-chetasam\nUdara-charitanam tu, vasudhaiva kutumbakam',
    meaning_en: 'This is mine, that is another\'s — such thinking is for the small-minded. For the noble-hearted, the entire world is one family.',
    meaning_hi: 'यह अपना है, वह पराया है — ऐसा विचार संकीर्ण लोगों का है। उदार हृदय वालों के लिए तो सम्पूर्ण वसुधा ही कुटुम्ब है।',
    source: 'महोपनिषद् ६.७२',
    source_en: 'Maha Upanishad 6.72',
  },

  // ─── VEDIC INVOCATIONS ────────────────────────────────────────────
  {
    id: 18,
    shloka: 'आ नो भद्राः क्रतवो यन्तु विश्वतो-\nऽदब्धासो अपरीतास उद्भिदः ॥',
    pronounce: 'Aa no bhadrah kratavo yantu vishwato\nAdabdhaso aparitasa udbhidah',
    meaning_en: 'Let noble thoughts come to us from every direction — unhindered, undefeated, and ever-flowing.',
    meaning_hi: 'हमारे पास सभी दिशाओं से शुभ विचार आएँ — अबाधित, अपराजित, और सदा प्रवाहित।',
    source: 'ऋग्वेद १.८९.१',
    source_en: 'Rigveda 1.89.1',
  },
  {
    id: 19,
    shloka: 'ॐ सह नाववतु । सह नौ भुनक्तु ।\nसह वीर्यं करवावहै ।\nतेजस्वि नावधीतमस्तु मा विद्विषावहै ।\nॐ शान्तिः शान्तिः शान्तिः ॥',
    pronounce: 'Om saha navavatu, saha nau bhunaktu\nSaha viryam karavavahai\nTejasvi navadhitam astu, ma vidvishavahai\nOm shantih shantih shantih',
    meaning_en: 'May we be protected together. May we be nourished together. May we work together with great energy. May our study be brilliant. May we never hate each other. Om, peace, peace, peace.',
    meaning_hi: 'हम दोनों की साथ रक्षा हो। हम दोनों का साथ पोषण हो। हम दोनों साथ मिलकर बल प्राप्त करें। हमारा अध्ययन तेजस्वी हो। हम एक-दूसरे से द्वेष न करें। ॐ शान्ति शान्ति शान्ति।',
    source: 'शान्ति मन्त्र — तैत्तिरीयोपनिषद्',
    source_en: 'Shanti Mantra — Taittiriya Upanishad',
  },
];
